import { unsafeCSS, html } from "lit";
import { classMap } from "lit/directives/class-map.js";
import { LeafElement } from "../leaf-element.js";
const styles = "/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n:host {\n  display: block;\n}\n:host ::slotted(leaf-accordion-panel:last-child) {\n  border-bottom: var(--leaf-border-width-default) solid var(--leaf-color-border-brand-subtle);\n}";
const _LeafAccordion = class _LeafAccordion extends LeafElement {
  get accordionPanels() {
    return Array.from(this.childNodes).filter(
      (node) => node.tagName && node.tagName.includes("LEAF-ACCORDION-PANEL")
    );
  }
  connectedCallback() {
    super.connectedCallback();
    this.accordionPanels.forEach((panel) => panel.setAttribute("role", "listitem"));
  }
  render() {
    const componentClassName = {
      "leaf-c-accordion": true
    };
    return html`
      <div class="${classMap(componentClassName)}" role="list">
        <slot></slot>
      </div>
    `;
  }
};
_LeafAccordion.styles = unsafeCSS(styles);
let LeafAccordion = _LeafAccordion;
export {
  LeafAccordion
};
//# sourceMappingURL=accordion.component.js.map
